import React, { Component } from "react";
import "./HomeTourModal.css";
import {injectIntl} from "react-intl";
import GirlTour from "../../../assets/images/girl_tour.png";

export class ExploreStep1 extends Component {

    render(){

        return (
            <React.Fragment>
                <div className="e-t-container">
                    <div className="e-t-texts e-t-texts-step1">
                        <p className="e-t-title">
                            ¡Hola, Bienvenido!
                        </p>
                        <p className="e-t-subtitle">
                            Si es la primera vez aquí, te enseñaremos paso a paso para que puedas trabajar correctamente con Bunkey, podemos empezar subiendo algunos <span className="e-t-span-color"> assets </span> , configurando tu cuenta invitando a otra persona a que participe en este espacio:
                        </p>
                        <p className="e-t-subtitle-mobile">
                            Si es la primera vez aquí, te enseñaremos paso a paso para que puedas trabajar correctamente con Bunkey
                        </p>
                    </div>
                    <div className="e-t-imgcont">
                      <img src={GirlTour} alt="girl" className="e-t-img"/>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default injectIntl(ExploreStep1);
